/* Copyright (c) 2023 CLOUDPILOTS Software & Consulting GmbH */

// import { Page, useGoogleAuth, MainButton } from '@cloudpilots/components';
import { Page } from '@cloudpilots/components';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
// import React, { useEffect } from 'react';
import React from 'react';
// import GoogleLoginInfo from './setup/google-login';
// import useSetup from './setup/hook';

const Row = ({ children }) => (
  <Grid container spacing={1} justifyContent='center'>
    <Grid item xs={12} md={10} lg={8}>
      {children}
    </Grid>
  </Grid>
);

Row.propTypes = {
  children: PropTypes.node,
};

// const setupScopes = [
//   'https://www.googleapis.com/auth/admin.directory.user.readonly',
//   'https://www.googleapis.com/auth/admin.directory.domain.readonly',
//   'https://www.googleapis.com/auth/admin.directory.customer.readonly',
// ];

const Home = ({ appName }) => {
  // const googleAuth = useGoogleAuth();
  // useEffect(() => {
  //   googleAuth.setScopes(setupScopes);
  // }, [googleAuth]);

  // const { loading, setupComplete, startSetup, status, steps } = useSetup();

  return (
    <Page>
      <Row>
        <Typography variant='h4' gutterBottom>
          {appName}
        </Typography>
        <Typography variant='body1' gutterBottom>
          CLOUDPILOTS is simply awesome!
        </Typography>
        {/* <GoogleLoginInfo />
        <MainButton onClick={startSetup} variant='contained'>
          Setup
        </MainButton> */}
      </Row>
    </Page>
  );
};

Home.propTypes = {
  appName: PropTypes.string,
};

export { Home as default };
